module.exports = __webpack_public_path__ + "static/shutterstock_211211362-3edba2046429c927811b48f5cbc52360.jpg";